import component from './containers/container';
import reducer, { actions } from './modules/slice';
import saga from './modules/saga';

export { saga, reducer, actions };
export default component;
